import { useEffect } from 'react';
import { Form } from 'antd';
import { useFormContext } from '../../Context';
import CronFormItem from './CronFormItem';
import moment from 'moment';
import './index.scss';

const parseInitialValues = (values) => {
  let crons;
  if (values?.crons?.length > 0) {
    crons = values.crons.filter(({ cron, nextRun }) => !_.isEmpty(cron) || !_.isEmpty(nextRun))
    for (const cron of crons) {
      cron.firstRun = moment(cron.nextRun)
    }
  } else {
    crons = []
  }
  return crons
}

const Cron = ({ form, title, ...props }) => {
  const { formValues, updateFormValues, cronMap, updateCronMap } = useFormContext();
  const initialValues = { crons: parseInitialValues(formValues) }

  useEffect(() => {
    for (const val of initialValues.crons) {
      const relevantCron = cronMap[val.uid] || { disabled: false };
      updateCronMap(val.uid, relevantCron)
    }
  }, [])

  return (
    <div className="task-form">
      <Form
        form={form}
        initialValues={initialValues}
        onValuesChange={(vals) => updateFormValues({ crons: vals })}
      >
        <CronFormItem form={form} />
      </Form>
    </div>
  );
}

export default Cron;
